import { API_BASE_URL } from "../../../constants/env";

const DIRECT_VIDEO_EXTS = ["mp4", "webm", "ogg", "mov", "avi", "mkv"];

const isDirectVideoUrl = (url: string): boolean => {
  const ext = url.split("?")[0].split(".").pop()?.toLowerCase() ?? "";
  return DIRECT_VIDEO_EXTS.includes(ext);
};

const toEmbedUrl = (url: string): string => {
  // youtube.com/watch?v=ID
  const ytWatch = url.match(/youtube\.com\/watch\?(?:.*&)?v=([^&]+)/);
  if (ytWatch) return `https://www.youtube.com/embed/${ytWatch[1]}`;

  // youtu.be/ID
  const ytShort = url.match(/youtu\.be\/([^?/]+)/);
  if (ytShort) return `https://www.youtube.com/embed/${ytShort[1]}`;

  // youtube.com/shorts/ID
  const ytShorts = url.match(/youtube\.com\/shorts\/([^?/]+)/);
  if (ytShorts) return `https://www.youtube.com/embed/${ytShorts[1]}`;

  // vimeo.com/ID  (not already player.vimeo.com)
  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  if (vimeo && !url.includes("player.vimeo")) return `https://player.vimeo.com/video/${vimeo[1]}`;

  return url; // any other URL — pass through as-is
};

export const getVideoData = (content: { video?: string; video_url?: string }) => {
  if (content.video) return {
    type: "file" as const,
    src: content.video.startsWith("http") ? content.video : `${API_BASE_URL}${content.video}`,
  };
  if (content.video_url) {
    const url = content.video_url;
    // Direct video file link → play natively; everything else → iframe
    if (isDirectVideoUrl(url)) return { type: "file" as const, src: url };
    return { type: "external" as const, src: toEmbedUrl(url) };
  }
  return null;
};

export const getCategoryColor = (category: string) => ({
  trending: { bg: "bg-red-100",    text: "text-red-800",    border: "border-red-300" },
  featured: { bg: "bg-purple-100", text: "text-purple-800", border: "border-purple-300" },
  new:      { bg: "bg-blue-100",   text: "text-blue-800",   border: "border-blue-300" },
} as Record<string, { bg: string; text: string; border: string }>)[category?.toLowerCase()]
  ?? { bg: "bg-gray-100", text: "text-gray-800", border: "border-gray-300" };
